import { defineMessages } from 'react-intl'

export default defineMessages({
  accessToken: {
    id: 'OrganizationUserProvisioningPage.AccountManagement.AccessToken',
    defaultMessage: 'Access Token'
  },
  clientId: {
    id: 'OrganizationUserProvisioningPage.AccountManagement.ClientId',
    defaultMessage: 'Client Id'
  },
  copy: {
    id: 'COPY',
    defaultMessage: 'COPY'
  },
  create: {
    id: 'OrganizationUserProvisioningPage.AccountManagement.CreateCredentials',
    defaultMessage: 'Create Credentials'
  },
  description: {
    id: 'OrganizationUserProvisioningPage.AccountManagement.Description',
    defaultMessage: 'For Organizations that want to use an API to manage accounts; Workgrid implements SCIM v2.'
  },
  none: {
    id: 'None',
    defaultMessage: 'None'
  },
  onlyDisplayedOnce: {
    id: 'OnlyDisplayedOnce',
    defaultMessage: '(this is only displayed once!)'
  },
  reset: {
    id: 'Reset',
    defaultMessage: 'Reset'
  },
  scimURL: {
    id: 'OrganizationUserProvisioningPage.AccountManagement.ScimEndpoint',
    defaultMessage: 'SCIM Endpoint'
  },
  secret: {
    id: 'OrganizationUserProvisioningPage.AccountManagement.ClientSecret',
    defaultMessage: 'Client Secret'
  },
  title: {
    id: 'OrganizationUserProvisioningPage.AccountManagement.Title',
    defaultMessage: 'Account Management API'
  }
})
